import { useNavigate, useParams } from "react-router-dom";

import { Box, CardMedia, IconButton, Skeleton, Container } from "@mui/material";

import { currentUser } from "@/App";
import AppIcon from "@/assets/app-icon.svg";
import BottomTabs from "@/components/BottomTabs";
import MainAppBar from "@/components/MainAppBar";
import MusicContainer from "@/components/MusicContainer";
import SideTabs from "@/components/SideTabs";
import { SubscribedProvider } from "@/providers/Subscribed";
import { useArtist } from "@/services/hooks";
import { Edit } from "@mui/icons-material";

export default function Music() {
  const navigate = useNavigate();
  const { artistKey } = useParams();

  const { data: artist } = useArtist(artistKey);

  return (
    <SubscribedProvider artistKey={artistKey}>
      <Container maxWidth="sm" disableGutters>
        <MainAppBar />

        <Box id="main-feed" sx={{ p: 2 }}>
          {!artist && (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="358px"
              style={{ borderRadius: "15px" }}
              sx={{ my: 1 }}
            />
          )}

          {artist && (
            <Box id="cover-photo" sx={{ position: "relative" }}>
              <CardMedia
                component="img"
                sx={{
                  width: "100%",
                  objectFit: "cover",
                  backgroundPosition: "center",
                  aspectRatio: "1/1",
                  borderRadius: "20px",
                }}
                image={artist.meta.artwork || AppIcon}
              />

              {currentUser.key === artist.key && (
                <IconButton
                  sx={{
                    position: "absolute",
                    bottom: 8,
                    left: 8,
                    opacity: 0.8,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                  onClick={() => navigate("/account")}
                >
                  <Edit />
                </IconButton>
              )}
            </Box>
          )}
        </Box>
        <MusicContainer artistKey={artistKey} />

        <BottomTabs />
        <SideTabs />
      </Container>
    </SubscribedProvider>
  );
}
